const auth = {
    redirectToOfficialSite: '鉴权异常，正在返回官网首页',
    redirectReasons: {
      signInInitFailed: '登录服务异常，正在返回官网首页',
      restoreAuthFailed: '登录状态恢复失败，正在返回官网首页',
      missingAuthState: '未获取到有效登录状态，正在返回官网首页',
      callbackFailed: '登录回调处理失败，正在返回官网首页',
      callbackSdkError: '认证服务回调异常，正在返回官网首页',
      callbackTimeout: '登录回调超时，正在返回官网首页',
      apiUnauthorized: '登录已失效，正在返回官网首页',
      logtoUnauthorized: '认证会话已失效，正在返回官网首页',
    },
  }

export default auth
